import { getSettingsUrl } from 'vl-common/src/lib/getSettingsURL';

// getSettingsURL returns triage-settings URL e.g https://ndevapi.virtuallucyweb.co.uk/v1/triage-settings/ndevadmin.virtuallucyweb.co.uk
// tryDeriveEndpointName truncates this to ndev
export const tryDeriveEndpointName = () => new URL(getSettingsUrl()).hostname.replace(/api.*/, '');

// tryDeriveApiUrl truncates this to https://ndevapi.virtuallucyweb.co.uk/v1/
export const tryDeriveApiUrl = () => getSettingsUrl().replace(/(\/v\d+)\/.*/, '$1');
